module.exports = __webpack_public_path__ + "static/fonts/Anton-Regular.b13e6268.ttf";